import React, { Component } from 'react'

export default class About extends Component {
    render() {
        return(
            <div>
                <section className="colorlib-about" data-section="about">
                    <div className="colorlib-narrow-content">
                        <div className="row">
                        <div className="col-md-12">
                                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                                <div className="col-md-12">
                                    <div className="about-desc">
                                    <span className="heading-meta">About Me</span>
                                    <h2 className="colorlib-heading">Who Am I?</h2>
                                    <p><big>I am a computer science grad student from University of Southampton who loves travelling and discovering new things. I am always curious on the development of technology to this date such as how it changes our daily lives is the reason for me to pursue my degree in Computer Science.</big></p>
                                    <p><big>Part-time coffee enthusiast who spend my free time doing all sorts of hobbies ranging from socializing, playing musical instruments (Piano, Guitar), doing sports (Football, Golf) and reading self-improvement books to be a better person everyday.</big></p>    
                                    </div>
                                </div>
                                </div>
                        </div>
                        </div>
                    </div>
                </section>
                <section className="colorlib-about">
                <div className="colorlib-narrow-content">
                    <div className="row">
                    <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                        <span className="heading-meta">What I Do?</span>
                        <h2 className="colorlib-heading">Here are some of my expertise</h2>
                    </div>    
                    </div>
                    <div className="row row-pt-md">
                    <div className="col-md-4 text-center animate-box">
                        <div className="services color-1">
                        <span className="icon">
                            <i className="icon-device-desktop"/>
                        </span>
                        <div className="desc">
                            <h3>Front-End Development</h3>
                            <p>I have experience in Front-End Development ranging from making high fidelity UI designs using Figma to developing a functional website using PHP, HTML/CSS, JavaScript, MYSQL</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4 text-center animate-box">
                        <div className="services color-3">
                        <span className="icon">
                            <i className="icon-bulb"/>
                        </span>
                        <div className="desc">
                            <h3>Object Oriented Programming</h3>
                            <p>Majoring in Computer Science, I have come across Object Oriented Programming a lot during my time in University. The main language that I used is Java</p>
                        </div>
                        </div>
                    </div>  
                    <div className="col-md-4 text-center animate-box">
                        <div className="services color-5">
                        <span className="icon">
                            <i className="icon-user"/>
                        </span>
                        <div className="desc">
                            <h3>Agile Methodologies</h3>
                            <p>Apart from the technical aspect of my skills, working as part of a team is essential and I am able to showcase this skill through the use of agile methology approach.</p>
                        </div>
                        </div>
                    </div>  
                    </div>
                </div>    
                </section>
            </div>
        )
    }
}